import { divideRounded, formatFixed, parseFixed } from './fixed-decimal.js';
import { Money } from './money.js';
/** Storage scale of percentage columns (`numeric(9,6)`, in percent units: 20 means 20 %). */
export const PERCENTAGE_SCALE = 6;
const ONE_HUNDRED_PERCENT_UNITS = 100n * 10n ** BigInt(PERCENTAGE_SCALE);
/** Immutable percentage in percent units (e.g. `"12.5"` = 12.5 %) at {@link PERCENTAGE_SCALE}. */
export class Percentage {
    units;
    constructor(
    /** Value in units of 10^-6 percent. */
    units) {
        this.units = units;
    }
    static of(value) {
        return new Percentage(parseFixed(value, PERCENTAGE_SCALE));
    }
    static ZERO = new Percentage(0n);
    static ONE_HUNDRED = new Percentage(ONE_HUNDRED_PERCENT_UNITS);
    static sum(items) {
        return new Percentage(items.reduce((total, item) => total + item.units, 0n));
    }
    add(other) {
        return new Percentage(this.units + other.units);
    }
    subtract(other) {
        return new Percentage(this.units - other.units);
    }
    compare(other) {
        if (this.units === other.units)
            return 0;
        return this.units < other.units ? -1 : 1;
    }
    equals(other) {
        return this.units === other.units;
    }
    /** True for a valid ownership share: 0 % < value ≤ 100 %. */
    isValidOwnershipShare() {
        return this.units > 0n && this.units <= ONE_HUNDRED_PERCENT_UNITS;
    }
    /**
     * `money × this %`, rounded to money storage scale with an explicit rounding mode. Distributing
     * any remainder across founders is a policy decision and is not done here.
     */
    applyTo(money, rounding) {
        const units = divideRounded(money.units * this.units, ONE_HUNDRED_PERCENT_UNITS, rounding);
        return Money.fromUnits(units, money.currency);
    }
    toDecimalString() {
        return formatFixed(this.units, PERCENTAGE_SCALE);
    }
    toString() {
        return `${this.toDecimalString()}%`;
    }
    toJSON() {
        return this.toDecimalString();
    }
}
//# sourceMappingURL=percentage.js.map